import type { CSSProperties, ReactNode } from 'react';

import styles from './modal-content.component.module.scss';

type Props = {
  children?: ReactNode | undefined;
  className?: string;
  style?: CSSProperties;
};

/**
 * @deprecated Use `@findy-code/yuffie/ui` instead.
 */
export const LegacyModalContent = ({ className, style, children }: Props) => {
  return (
    <div
      className={[styles.modalContentWrapper, className]
        .filter(Boolean)
        .join(' ')}
      style={style}
    >
      <div className={styles.modalContentInner}>{children}</div>
    </div>
  );
};
